import { chain } from 'lodash';
import {
    INTEGRATION_TYPE,
    PAGE_VIEW_EVENT_NAME,
    S2S_INTEGRATION_TYPES,
    TYPE_INDICATORS,
} from '../config/pixelTesterConsts';

export const prettifyJson = jsonString => {
    try {
        return JSON.stringify(JSON.parse(jsonString), null, 2);
    } catch {
        return jsonString;
    }
};

export const extractConditions = event => {
    if (!event?.matchedRules) return [];

    return chain(event.matchedRules)
        .transform((acc, rule) => {
            if (rule?.condition?.property === 'URL') {
                const { value, predicate } = rule.condition;
                acc[value] = { name: predicate, value };
            }
        }, {})
        .values()
        .value();
};

export const getUpdatedEventsData = (events, defaultShopifyEvents, showUserMatchingIssues, showUserConsent) => {
    let eventsIssuesCount = 0;
    let eventsWorstIssueType = TYPE_INDICATORS.OK;

    const pixelTesterEvents = events?.map(event => {
        let userMatchingIssueType = TYPE_INDICATORS.OK;
        let worstIssueType = TYPE_INDICATORS.OK;

        const isDefaultShopifyEvent =
            event.pixelIntegrationType === INTEGRATION_TYPE.SHOPIFY_APP &&
            defaultShopifyEvents.includes(event.eventName);

        if (!isDefaultShopifyEvent) {
            const hasValidationErrors = event.eventParameters?.some(param => param.validationError != null);
            const isUnrecognisedEvent = !event.matchedRules?.length && event.eventName !== PAGE_VIEW_EVENT_NAME;
            userMatchingIssueType = getEventUserMatchingIssueType(event, showUserMatchingIssues, showUserConsent);
            worstIssueType = getEventWorstIssueType(hasValidationErrors, isUnrecognisedEvent, userMatchingIssueType);
            eventsIssuesCount = updateEventsIssuesCount(eventsIssuesCount, worstIssueType);
            eventsWorstIssueType = updateEventsWorstIssueType(eventsWorstIssueType, worstIssueType);
        }
        return { ...event, issues: { worstIssueType, userMatchingIssueType } };
    });

    return { pixelTesterEvents, eventsIssuesCount, eventsWorstIssueType };
};

const getEventUserMatchingIssueType = (event, showUserMatchingIssues, showUserConsent) => {
    return showUserMatchingIssues
        ? getUserMatchingIssueType(event?.userMatching, isS2sIntegration(event?.pixelIntegrationType), showUserConsent)
        : TYPE_INDICATORS.OK;
};

const getEventWorstIssueType = (hasValidationErrors, isUnrecognisedEvent, userMatchingIssueType) => {
    if (hasValidationErrors || isUnrecognisedEvent || userMatchingIssueType === TYPE_INDICATORS.ERROR)
        return TYPE_INDICATORS.ERROR;
    else if (userMatchingIssueType === TYPE_INDICATORS.ALERT) return TYPE_INDICATORS.ALERT;
    return TYPE_INDICATORS.OK;
};

const updateEventsIssuesCount = (eventsIssuesCount, eventWorstIssueType) => {
    return eventWorstIssueType !== TYPE_INDICATORS.OK ? eventsIssuesCount + 1 : eventsIssuesCount;
};

const updateEventsWorstIssueType = (eventsWorstIssueType, eventWorstIssueType) => {
    if (eventsWorstIssueType === TYPE_INDICATORS.ERROR || eventWorstIssueType === TYPE_INDICATORS.ERROR)
        return TYPE_INDICATORS.ERROR;
    else if (eventsWorstIssueType === TYPE_INDICATORS.ALERT || eventWorstIssueType === TYPE_INDICATORS.ALERT)
        return TYPE_INDICATORS.ALERT;
    return TYPE_INDICATORS.OK;
};

export const countUserMatchingIssues = (userMatchingData, hideCookieConsentData, showUserConsent) => {
    if (hideCookieConsentData) return userMatchingData?.clickId ? 0 : 1;
    else if (showUserConsent) return Object.values(userMatchingData)?.filter(indicator => !indicator)?.length;
    else {
        let issuesCounter = 0;
        if (!userMatchingData?.clickId) issuesCounter++;
        if (!userMatchingData?.cookieId) issuesCounter++;
        return issuesCounter;
    }
};

export const getUserMatchingIssueType = (userMatchingData, hideCookieConsentData, showUserConsent) => {
    if (hideCookieConsentData) {
        if (userMatchingData?.clickId) return TYPE_INDICATORS.OK;
        return TYPE_INDICATORS.ERROR;
    }
    if (!userMatchingData?.clickId) return TYPE_INDICATORS.ERROR;
    if (!userMatchingData?.cookieId || (showUserConsent && !userMatchingData?.isUserConsent))
        return TYPE_INDICATORS.ALERT;
    return TYPE_INDICATORS.OK;
};

export const isS2sIntegration = pixelIntegrationType => {
    return S2S_INTEGRATION_TYPES?.some(type => type === pixelIntegrationType);
};
